import { Box, Typography, FormControlLabel, Switch } from "@mui/material";
import theme from "../../../../../theme";

// Const
const FILTER_PADDING_X = 2;
const FILTER_PADDING_Y = 1.5;
const DIVIDER_HEIGHT = 24;

export const NewsFilters = ({
  itemsCount,
  totalCount,
  bookmarksCount,
  showBookmarksOnly,
  onToggleBookmarks,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        gap: 2,
        backgroundColor: "primary.main",
        borderRadius: theme.borderRadius.small,
        px: FILTER_PADDING_X,
        py: FILTER_PADDING_Y,
      }}
    >
      {/* Results Count */}
      <Typography variant="caption" sx={{ color: "primary.white" }}>
        Showing{" "}
        <Box
          component="span"
          style={{
            color: theme.palette.primary.brandSecondary,
            fontWeight: "bold",
          }}
        >
          {itemsCount}
        </Box>{" "}
        results of{" "}
        <Box
          component="span"
          style={{
            color: theme.palette.primary.brandSecondary,
            fontWeight: "bold",
          }}
        >
          {totalCount || 0}
        </Box>{" "}
        items
      </Typography>

      {/* Divider */}
      <Box
        sx={{
          borderLeft: `2px solid ${theme.palette.primary.mistGray}60`,
          height: DIVIDER_HEIGHT,
          mx: 1,
        }}
      />

      {/* Bookmarks Count */}
      <Typography variant="caption" sx={{ color: "primary.white" }}>
        <Box
          component="span"
          style={{
            color: theme.palette.primary.brandSecondary,
            fontWeight: "bold",
          }}
        >
          {bookmarksCount}
        </Box>{" "}
        Bookmarks Saved
      </Typography>

      {/* Divider */}
      <Box
        sx={{
          borderLeft: `2px solid ${theme.palette.primary.mistGray}60`,
          height: DIVIDER_HEIGHT,
          mx: 1,
        }}
      />

      {/* Bookmarks Toggle */}
      <FormControlLabel
        control={
          <Switch
            checked={showBookmarksOnly}
            onChange={(e) => onToggleBookmarks(e.target.checked)}
            sx={{
              "& .MuiSwitch-switchBase": {
                color: "white",
                "&.Mui-checked": {
                  color: "primary.brandSecondary",
                  "& + .MuiSwitch-track": {
                    backgroundColor: "primary.brandSecondary",
                  },
                },
                "& + .MuiSwitch-track": {
                  backgroundColor: "primary.brandSecondary",
                },
              },
            }}
          />
        }
        label={
          <Typography variant="caption" sx={{ mr: 2, color: "primary.white" }}>
            Show Bookmarks Only
          </Typography>
        }
        labelPlacement="start"
      />
    </Box>
  );
};
